export default "__VITE_ASSET__CljYvWTG__"